var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-composable-checkpoint", {
    attrs: { draggable: _vm.canWrite, name: _vm.checkpoint.displayName },
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function() {
          return [
            _vm.checkpoint.iconClass
              ? _c("i", { class: _vm.checkpoint.iconClass })
              : _vm._e(),
            _vm._v(" "),
            _vm.checkpoint.iconPath
              ? _c("img", {
                  attrs: { src: _vm.checkpoint.iconPath, draggable: "false" }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }